module.exports = __webpack_public_path__ + "static/media/bike3.40f5eacb.jpg";